const routes = [
  {
    name: 'main',
    path: '/',
    meta: {
      authorization: {
        authenticated: true,
      },
    },
    component: () => import('@/views/Dashboard.vue'),
    children: [
      {
        name: 'home',
        path: '/',
        component: () => import('@/views/home/HomeView.vue'),
        meta: {
          authorization: {
            requiresAuth: true,
          },
        },
      },
      {
        name: 'createRequest',
        path: '/request/new',
        component: () => import('@/views/request/CreateRequestView.vue'),
        meta: {
          authorization: {
            requiresAuth: true,
          },
        },
      },
      {
        name: 'editRequest',
        path: '/request/:businessId',
        component: () => import('@/views/request/EditRequestView.vue'),
        meta: {
          authorization: {
            requiresAuth: true,
          },
        },
      },
      {
        name: 'userProfile',
        path: '/profile',
        component: () => import('@/views/profile/UserProfileView.vue'),
        meta: {
          authorization: {
            requiresAuth: true,
          },
        },
      },
    ],
  },
  {
    name: 'signin',
    path: '/signin',
    component: () => import('@/views/auth/SignIn.vue'),
  },
  {
    name: 'register',
    path: '/register',
    component: () => import('@/views/register/RegisterView.vue'),
    meta: {
      authorization: {
        requiresAuth: false,
      },
    },
  },
  {
    path: '*',
    redirect: { name: 'main' },
  },
];

export default routes;
